import { useRef } from 'react';
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import useLaunchGameEvents from '~/client/components/Game/umamiEvents/useGameEvents';
import WCContainer from './WCContainer';
import sendEventToUmami from '@/client/helpers/trackEvent/sendEventToUmami';
import isWebComponentGame from '@/shared/utils/isWebComponentGame';

const GameFrame: FC = () => {
  const eventSent = useRef<boolean>(false);
  const { game, gameSession } = useGameContext();
  const handle = game?.handle;
  const isMetaverseCasino = handle === 'metaverse-casino';
  const providerName = game?.menuItem?.[0]?.name;
  const isLiveSolutions = providerName === 'Live Solutions';
  const launchEvents = useLaunchGameEvents();

  const sendEvent = () => {
    if (eventSent.current) {
      return;
    }

    // eslint-disable-next-line immutable/no-mutation
    eventSent.current = true;

    launchEvents();
  };

  if (isWebComponentGame(handle) && gameSession?.url) {
    return <WCContainer gameLaunchUrl={gameSession.url} />;
  }

  if (isMetaverseCasino || isLiveSolutions) {
    return (
      <div className="absolute h-full w-full" id="game-fullscreen-container">
        <iframe
          className="h-full w-full border-0"
          id="gameIframe"
          allow="camera *; microphone *; autoplay *"
          src={gameSession?.url}
          allowFullScreen
          onLoad={sendEvent}
          onError={() => {
            sendEventToUmami({}, 'launchGameError');
          }}
        />
      </div>
    );
  }

  return (
    <div className="absolute h-full w-full" id="game-fullscreen-container">
      <iframe
        id="gameIframe"
        src={gameSession?.url}
        allowFullScreen
        className="h-full w-full border-0"
        onLoad={sendEvent}
        onError={() => {
          sendEventToUmami({}, 'launchGameError');
        }}
      />
    </div>
  );
};

export default GameFrame;
